import { useAuthStore } from '@/stores/authStore'
import { hasFeature } from '@/lib/planFeatures'
import { LiveNowBanner } from './LiveNowBanner'
import { conductedSessions } from './liveNow'
import { useLiveNow } from './useLiveNow'

export const STUDENT_LIVE_SESSIONS_PATH = '/app/aulas-ao-vivo'
export const INSTRUCTOR_LIVE_SESSIONS_PATH = '/instructor/aulas-ao-vivo'

/** R10-12 — o aluno tem aula ao vivo agora? So consulta se o plano libera a area. */
export function useStudentLiveNow() {
  const user = useAuthStore((state) => state.user)
  return useLiveNow(Boolean(user) && hasFeature(user, 'aulas_ao_vivo'))
}

/** R10-12 — aulas que o instrutor conduz agora (host ou panelista). */
export function useInstructorLiveNow() {
  const user = useAuthStore((state) => state.user)
  const query = useLiveNow(Boolean(user))
  return conductedSessions(query.data)
}

/** Faixa do topo do app do aluno (DashboardLayout). */
export function StudentLiveNowNotice() {
  const { data } = useStudentLiveNow()
  return <LiveNowBanner sessions={data} basePath={STUDENT_LIVE_SESSIONS_PATH} />
}

/** Faixa do topo da area do instrutor (InstructorLayout). */
export function InstructorLiveNowNotice() {
  const sessions = useInstructorLiveNow()
  return <LiveNowBanner sessions={sessions} basePath={INSTRUCTOR_LIVE_SESSIONS_PATH} />
}
